export const APM_PAYMENT_METHOD_NAME = "APM";
